import { getPreselectedLanguageCode } from '@libs/helpers';
import { AppLangCode } from '@libs/types';
import { useCallback, useState } from 'react';
import { BrandName } from './constants';
export const TRANSLATION_MISSED = 'Translation missed';
export const useLanguage = (languages, defaultLng, currentJurisdiction) => {
    const [texts, setText] = useState(defaultLng || {});
    const { defaultLanguageCode } = getPreselectedLanguageCode(currentJurisdiction);
    const [selectedLanguageCode, setSelectedLanguageCode] = useState(defaultLanguageCode);
    const t = useCallback((key, replacements) => {
        if (!key)
            return '';
        let newKey = key;
        let returnedValue = texts[newKey];
        if (currentJurisdiction) {
            if (currentJurisdiction + '_' + key in texts) {
                newKey = currentJurisdiction + '_' + key;
            }
            if (typeof texts[newKey] === 'string') {
                returnedValue = texts[newKey]
                    .split(`{{ brandName }}`)
                    .join(BrandName[currentJurisdiction]);
            }
        }
        const replacementKeys = Object.keys(replacements || {});
        if (replacementKeys.length) {
            return replacementKeys.reduce((acc, curr) => {
                const value = replacements?.[curr] || '';
                const isPluralCount = typeof +value === 'number' && +value > 1;
                if (isPluralCount) {
                    const pluralText = texts[key + '_plural'];
                    if (pluralText) {
                        return pluralText.split(`{{ ${curr} }}`).join(value.toString());
                    }
                }
                return acc.split(`{{ ${curr} }}`).join(value.toString());
            }, returnedValue || '');
        }
        return returnedValue || TRANSLATION_MISSED;
    }, [currentJurisdiction, texts]);
    const changeLanguage = useCallback((lang) => {
        const selectedLang = languages?.[lang];
        if (selectedLang) {
            setText(selectedLang);
            localStorage.setItem('language', lang);
            setSelectedLanguageCode(lang);
        }
    }, [languages]);
    const toggleLanguage = useCallback(() => {
        const langToChange = AppLangCode.EN === selectedLanguageCode ? AppLangCode.KA : AppLangCode.EN;
        changeLanguage(langToChange);
        setSelectedLanguageCode(langToChange);
    }, [changeLanguage, selectedLanguageCode]);
    return {
        t,
        texts,
        changeLanguage,
        toggleLanguage,
        selectedLanguageCode,
    };
};
//# sourceMappingURL=useLanguage.js.map